import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
/**
 * Composable to handle generic waiters/loaders
 *
 * How to use:
 * `startWaiter(waiterName)` to add and start a new loader
 * `isWaiting(waiterName)` to check if the given loader is active
 * `removeWaiter(waiterName)` to stop the given loader
 *
 * To handle multple loaders on the same component it is recommended to use the "dot" notation.
 * e.g. `plp.contentful` and `plp.commercetools`
 */
export function useWait() {
  var waiters = useState('waiters', function () {
    return [];
  });

  /**
   * Starts a waiter.
   */
  function startWaiter(waiter) {
    if (!waiters.value.includes(waiter)) waiters.value.push(waiter);
  }

  /**
   * Ends a waiter.
   */
  function endWaiter(waiter) {
    waiters.value = waiters.value.filter(function (el) {
      return el !== waiter;
    });
  }

  /**
   * Determines whether the specified waiter is waiting.
   *
   * @param      {string}   waiter  The waiter
   * @return     {boolean}  True if the specified waiter is waiting, False otherwise.
   */
  function isWaiting(waiter) {
    return waiters.value.includes(waiter);
  }

  /**
   * Reset all waiters
   */
  function resetWaiters() {
    waiters.value = [];
  }
  return {
    waiters: waiters,
    startWaiter: startWaiter,
    endWaiter: endWaiter,
    isWaiting: isWaiting,
    resetWaiters: resetWaiters
  };
}